// extracted by mini-css-extract-plugin
module.exports = {"content":"LoginFooter_content__2FVJw","text":"LoginFooter_text__3EQtR","link":"LoginFooter_link__DGIgu"};